import { createAsyncThunk } from '@reduxjs/toolkit'
import MediaList from './media-list-model'
import {
  delete_mediaList,
  load_mediaLists,
  store_mediaList,
} from './mediaList-service'

export const LoadMediaListsAsync = createAsyncThunk<any, any>(
  'composer/load/mediaList',
  async (params: { uid: string }) => {
    return await load_mediaLists(params)
  },
)

export const CreateMediaListAsync = createAsyncThunk<any, any>(
  'composer/create/mediaList',
  async (params: MediaList) => {
    return await store_mediaList(params)
  },
)

export const DeleteMediaListAsync = createAsyncThunk<any, any>(
  'composer/delete/mediaList',
  async (params) => {
    return await delete_mediaList(params)
  },
)
